import { useCallback, useMemo } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { View } from 'react-native';
import { parseISO, isValid } from 'date-fns';
import { MealType } from '@fytness/shared';
import { MealLogScreen } from '~/meal/components/meal-log-screen/MealLogScreen';

const VALID_TYPES = new Set(Object.values(MealType));

export default function MealDatePage() {
  const { date: dateParam, type: typeParam } = useLocalSearchParams<{
    date: string;
    type?: string;
  }>();
  const router = useRouter();

  const date = useMemo(() => {
    if (!dateParam) return new Date();
    const parsed = parseISO(dateParam);
    return isValid(parsed) ? parsed : new Date();
  }, [dateParam]);

  const selectedType = useMemo(() => {
    const upper = typeParam?.toUpperCase();
    return upper && VALID_TYPES.has(upper as MealType)
      ? (upper as MealType)
      : MealType.BREAKFAST;
  }, [typeParam]);

  const handleTypeChange = useCallback(
    (type: MealType) => {
      router.setParams({ type });
    },
    [router],
  );

  return (
    <View className="flex-1 bg-background">
      <MealLogScreen
        date={date}
        selectedType={selectedType}
        onTypeChange={handleTypeChange}
      />
    </View>
  );
}
